<template>
    <label
        class="tl-input-radio"
        :class="{
            'tl-input-radio-active': model === value,
            'tl-input-radio-disabled': disabled,
            'tl-input-radio-error': error,
        }"
        role="radio"
        :aria-checked="model === value"
    >
        <div class="tl-input-radio-selector">
            <input
                :id="id"
                type="radio"
                :name="name"
                :value="value"
                :disabled="!!disabled"
                :aria-disabled="disabled"
                @change="onChange"
            >
        </div>
        <span
            class="tl-input-radio-label"
            v-html="label"
        />
    </label>
</template>

<script setup lang="ts">
import { computed, useId } from 'vue'
import marked from 'widget-components/utilities/marked'

const props = defineProps<{
    value: string
    label: string
    disabled?: boolean
    error?: boolean
    name: string
}>()

const id = useId()
const model = defineModel<string>({ default: '' })
const label = computed(() => marked(props.label))

const onChange = () => {
    if (!props.disabled) {
        model.value = props.value
    }
}
</script>

<style lang="sass" scoped>
@import './InputRadioSelector.sass'
</style>
